import { Linking } from 'react-native'
import { trackEventAndNavigateWithParams, trackEventByAnalyticId } from './helpers'
import { regionalContentLookup } from '../components/methods/RegionalContentLookUp'

export const faqItemTapped = (itemTapped, trackId) => {
    trackEventAndNavigateWithParams(trackId, 'FAQItemPage', { tappedItem: itemTapped })
    return {
        type: 'FAQ_ITEM_TAPPED',
        payload: itemTapped,
    }
}

export const webViewTapped = (url, shortName) => {
    trackEventByAnalyticId(shortName || url)
    if (url && window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(`showWeb;${url}`)
    } else if (url) {
        Linking.openURL(url)
    }
}

export const patientManualTapped = (pageKey) => (dispatch, getState) => {
    const url = regionalContentLookup('manualURL')(dispatch, getState)
    if (url && window.ReactNativeWebView) {
        trackEventByAnalyticId(pageKey)
        window.ReactNativeWebView.postMessage(`showManual;${pageKey}`)
    } else if (url) {
        Linking.openURL(url)
    }
}
